import {createRoot} from 'react-dom/client';
import React from 'react';
import {Home} from './Home/Home';
import './style.scss';

const root = createRoot(document.getElementById('app-mount'));

root.render(<Home/>);
